import { useEffect } from 'react';
import { bridge } from 'shared/src/utils';
import { useMyPageRoute } from './useMyPageRoute';

const MyPageScreenList = {
  Laboratory: 'LABORATORY',
};

export type MyPageScreenKeys = keyof typeof MyPageScreenList;

export const useSetScreenName = (screen: MyPageScreenKeys) => {
  const { instanceId } = useMyPageRoute();
  const screenName = MyPageScreenList[screen];
  useEffect(() => {
    bridge.setScreenName({ instanceId: instanceId, name: screenName });
  }, [instanceId, screenName]);
};
